'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _localforage = require('localforage');

var _localforage2 = _interopRequireDefault(_localforage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

try {
    _localforage2.default.config({
        name: 'platformProjectModelCache',
        storeName: 'platformCache',
        driver: [_localforage2.default.INDEXEDDB, _localforage2.default.WEBSQL, _localforage2.default.LOCALSTORAGE],
        size: 4980736,
        version: 1.0,
        description: 'request store DB'
    });
} catch (e) {
    console.log('localforage error:', e);
}

var Cache = function () {
    function Cache() {
        _classCallCheck(this, Cache);
    }

    _createClass(Cache, null, [{
        key: '_isString',

        /**
         * @param {string} str 需要检测的数据
         * @description 判断是否为字符串
         */
        value: function _isString(data) {
            return typeof data === 'string';
        }
        /**
         * @param {string} itemKey 传入的key
         * @returns {string}
         * @description 将本地存储键与location.pathname连接
         */

    }, {
        key: '_getItemKey',
        value: function _getItemKey(itemKey) {
            return 'platform-project/' + itemKey;
        }
        /**
         * @param {string} itemKey 要读取的key值
         * @returns {object}
         * @description  读取
         */

    }, {
        key: '_getItem',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(itemKey) {
                var key, cacheData, now;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this._isString(itemKey)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                key = this._getItemKey(itemKey);
                                _context.prev = 3;
                                _context.next = 6;
                                return _localforage2.default.getItem(key);

                            case 6:
                                cacheData = _context.sent;

                                if (!cacheData) {
                                    _context.next = 17;
                                    break;
                                }

                                now = Date.now();

                                if (!(typeof cacheData.expire === 'boolean' && cacheData.expire || typeof cacheData.expire === 'number' && now >= cacheData.time + cacheData.expire)) {
                                    _context.next = 14;
                                    break;
                                }

                                _localforage2.default.removeItem(key);
                                return _context.abrupt('return', null);

                            case 14:
                                return _context.abrupt('return', cacheData.rawValue);

                            case 15:
                                _context.next = 18;
                                break;

                            case 17:
                                return _context.abrupt('return', null);

                            case 18:
                                _context.next = 23;
                                break;

                            case 20:
                                _context.prev = 20;
                                _context.t0 = _context['catch'](3);
                                return _context.abrupt('return', null);

                            case 23:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[3, 20]]);
            }));

            function _getItem(_x) {
                return _ref.apply(this, arguments);
            }

            return _getItem;
        }()
        /**
         * @param {string} itemKey 存入的key
         * @param {object} rawValue 存入的值
         * @param {number} expire  过期时间
         * @description 写入
         */

    }, {
        key: '_setItem',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(itemKey, rawValue, expire) {
                var key, cacheData;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (this._isString(itemKey)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                if (!(typeof expire !== 'boolean' && isNaN(expire))) {
                                    _context2.next = 5;
                                    break;
                                }

                                console.error('过期时间参数不合法');
                                return _context2.abrupt('return');

                            case 5:
                                key = this._getItemKey(itemKey);
                                cacheData = {
                                    rawValue: rawValue,
                                    time: Date.now(),
                                    expire: expire
                                };
                                _context2.prev = 7;
                                _context2.next = 10;
                                return _localforage2.default.setItem(key, cacheData);

                            case 10:
                                _context2.next = 24;
                                break;

                            case 12:
                                _context2.prev = 12;
                                _context2.t0 = _context2['catch'](7);
                                _context2.next = 16;
                                return this.cleanExpire();

                            case 16:
                                _context2.prev = 16;
                                _context2.next = 19;
                                return _localforage2.default.setItem(key, cacheData).catch(function () {});

                            case 19:
                                _context2.next = 24;
                                break;

                            case 21:
                                _context2.prev = 21;
                                _context2.t1 = _context2['catch'](16);

                                console.error('存储空间已满');

                            case 24:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[7, 12], [16, 21]]);
            }));

            function _setItem(_x2, _x3, _x4) {
                return _ref2.apply(this, arguments);
            }

            return _setItem;
        }()
        /**
         * @param {String} itemKey 要删除的key值
         * @description 删除
         */

    }, {
        key: '_removeItem',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(itemKey) {
                var key;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (this._isString(itemKey)) {
                                    _context3.next = 2;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 2:
                                key = this._getItemKey(itemKey);
                                _context3.prev = 3;
                                _context3.next = 6;
                                return _localforage2.default.removeItem(key).catch(function () {});

                            case 6:
                                _context3.next = 11;
                                break;

                            case 8:
                                _context3.prev = 8;
                                _context3.t0 = _context3['catch'](3);

                                console.log('removeItem失败:', _context3.t0);

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[3, 8]]);
            }));

            function _removeItem(_x5) {
                return _ref3.apply(this, arguments);
            }

            return _removeItem;
        }()
        /**
         * @param {String} itemKey 需要获取的key值
         * @description 从本地存储获取值
         */

    }, {
        key: 'get',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(itemKey) {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this._getItem(itemKey);

                            case 2:
                                return _context4.abrupt('return', _context4.sent);

                            case 3:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function get(_x6) {
                return _ref4.apply(this, arguments);
            }

            return get;
        }()
        /**
         * @param {String} itemKey 存入key值
         * @param {object} value 存入值
         * @param {Number} expire 存入过期时间 默认7天
         * @description 设置本地存储值
         */

    }, {
        key: 'set',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(itemKey, rawValue) {
                var expire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000 * 60 * 60 * 24 * 7;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this._setItem(itemKey, rawValue, expire);

                            case 2:
                                return _context5.abrupt('return', _context5.sent);

                            case 3:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function set(_x8, _x9) {
                return _ref5.apply(this, arguments);
            }

            return set;
        }()
        /**
         * @param {String} itemKey 要删除的key值
         * @description 从本地存储中移除值
         */

    }, {
        key: 'remove',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(itemKey) {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this._removeItem(itemKey);

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function remove(_x10) {
                return _ref6.apply(this, arguments);
            }

            return remove;
        }()
        /**
         * @description 清除过期的数据
         */

    }, {
        key: 'cleanExpire',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var allTask, length, i, key, cacheData, now;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                allTask = [];
                                _context7.prev = 1;
                                _context7.next = 4;
                                return _localforage2.default.length();

                            case 4:
                                length = _context7.sent;
                                i = 0;

                            case 6:
                                if (!(i < length)) {
                                    _context7.next = 18;
                                    break;
                                }

                                _context7.next = 9;
                                return _localforage2.default.key(i);

                            case 9:
                                key = _context7.sent;
                                _context7.next = 12;
                                return _localforage2.default.getItem(key);

                            case 12:
                                cacheData = _context7.sent;
                                now = Date.now();

                                if (typeof cacheData.expire === 'boolean' && cacheData.expire || typeof cacheData.expire === 'number' && now >= cacheData.time + cacheData.expire) {
                                    allTask.push(_localforage2.default.removeItem(key));
                                }

                            case 15:
                                i++;
                                _context7.next = 6;
                                break;

                            case 18:
                                _context7.next = 23;
                                break;

                            case 20:
                                _context7.prev = 20;
                                _context7.t0 = _context7['catch'](1);

                                console.log('cleanExpire:', _context7.t0);

                            case 23:
                                _context7.next = 25;
                                return Promise.all(allTask);

                            case 25:
                                return _context7.abrupt('return', _context7.sent);

                            case 26:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this, [[1, 20]]);
            }));

            function cleanExpire() {
                return _ref7.apply(this, arguments);
            }

            return cleanExpire;
        }()
        /**
         * @description 清除本地存储
         */

    }, {
        key: 'clear',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.prev = 0;
                                _context8.next = 3;
                                return _localforage2.default.clear().catch(function () {});

                            case 3:
                                _context8.next = 8;
                                break;

                            case 5:
                                _context8.prev = 5;
                                _context8.t0 = _context8['catch'](0);

                                console.log('clear:', _context8.t0);

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this, [[0, 5]]);
            }));

            function clear() {
                return _ref8.apply(this, arguments);
            }

            return clear;
        }()
    }]);

    return Cache;
}();

exports.default = Cache;